/**
 * Guided setup checklist (tracker item 75). Mirrors backend
 * modules/setup/setup.types.ts.
 */

export type SetupStepKey =
  | 'company_profile'
  | 'timezone_hours'
  | 'tax_rate'
  | 'payment_terms'
  | 'items'
  | 'price_chart'
  | 'users'
  | 'email_sender'
  | 'square'
  | 'portal';

export interface SetupStep {
  key: SetupStepKey;
  title: string;
  /** Optional steps never block "complete" */
  optional: boolean;
  /** Mark done is available (no data proves the step) */
  manual: boolean;
  done: boolean;
  /** Skipped and not done */
  skipped: boolean;
  /** Route of the page that configures the step */
  link: string;
}

export interface SetupProgress {
  steps: SetupStep[];
  /** The checklist is hidden (Hide checklist; Settings > Show setup checklist) */
  dismissed: boolean;
  doneCount: number;
  /** Done or skipped */
  resolvedCount: number;
  total: number;
  /** No required step is open (each is done or skipped) */
  complete: boolean;
}

/** Backend error codes of the setup routes. */
export const SETUP_ERROR_CODES = {
  unknownStep: 'SETUP_UNKNOWN_STEP',
  stepDone: 'SETUP_STEP_DONE',
  stepNotManual: 'SETUP_STEP_NOT_MANUAL',
} as const;
